// @ts-nocheck

import FabricChart from './ecgChart';

let ECGChart;

(function () {
  ECGChart = function (
    chartData: any,
    configJSON: any,
    beatMarkerArr: any,
    annotations: any,
    objectFunctions: any,
    isDisplayScrollbar: any,
    hiddenChannels: any,
    eventPos: any,
    missingSampleLength: any,
    diagnosticLead: any,
    timeObject: any,
    index: any,
    isStreaming: any,
    isLoading: any,
  ) {
    // oxlint-disable-next-line import/no-named-as-default-member
    const _ecgChart = new FabricChart.ECGChart(
      chartData,
      configJSON,
      beatMarkerArr,
      annotations,
      objectFunctions,
      isDisplayScrollbar,
      hiddenChannels,
      eventPos,
      missingSampleLength,
      diagnosticLead,
      timeObject,
      index,
      isStreaming,
      isLoading,
    );

    this.updateECGChart = (
      chartData: any,
      configJSON: any,
      beatMarkerArr: any,
      annotations: any,
      isDisplayScrollbar: any,
      hiddenChannels: any,
      eventPos: any,
      missingSampleLength: any,
      diagnosticLead: any,
      timeObject: any,
    ) => {
      _ecgChart.updateData(
        chartData,
        configJSON,
        beatMarkerArr,
        annotations,
        isDisplayScrollbar,
        hiddenChannels,
        eventPos,
        missingSampleLength,
        diagnosticLead,
        timeObject,
      );
    };

    this.showHideBeatMarkers = (isVisibility: any, shouldUpdateConfig: any) => {
      _ecgChart.showHideBeatMarkers(isVisibility, shouldUpdateConfig);
    };

    this.getDrawingHLineStatus = () => _ecgChart.getDrawingHLineStatus();

    this.getDrawingVLineStatus = () => _ecgChart.getDrawingVLineStatus();

    this.getSelectingStatus = () => _ecgChart.getSelectingStatus();

    this.getViewAllModeStatus = () => _ecgChart.getViewAllModeStatus();

    this.getWidgets = () => _ecgChart.getWidgets();

    this.getBeatMarkers = () => _ecgChart.getBeatMarkers();

    this.deleteObject = () => {
      _ecgChart.deleteObject();
    };

    this.getWndDuration = () => _ecgChart.getWndDuration();

    // this.jumpTo = (position, durationSec) => {
    //   _ecgChart.jumpTo(position, durationSec);
    // };

    // this.markAnEvent = (eventDescriptor) => {
    //   _ecgChart.markAnEvent(eventDescriptor);
    // };

    // this.markAnSpecifyEvent = (durationSec, eventDescriptor) => {
    //   _ecgChart.markAnSpecifyEvent(durationSec, eventDescriptor);
    // };

    // this.getMaxJump = () => _ecgChart.getMaxJump();

    this.saveContextMenuPosition = (point: any) => {
      _ecgChart.saveContextMenuPosition(point);
    };

    this.handleDrawHorizCaliperMouseOver = () => {
      _ecgChart.handleDrawHorizCaliperMouseOver();
    };

    this.handleDrawHorizCaliperMouseOut = (propsLayer: any) => {
      _ecgChart.handleDrawHorizCaliperMouseOut(propsLayer);
    };

    this.getLineColor = () => _ecgChart.getLineColor();

    this.changeHLineColor = (color: any) => {
      _ecgChart.changeHLineColor(color);
    };

    this.changeVLineColor = (color: any) => {
      _ecgChart.changeVLineColor(color);
    };

    this.changePatternColor = (color: any) => {
      _ecgChart.changePatternColor(color);
    };

    this.drawAnnotation = (type: any) => {
      _ecgChart.drawAnnotation(type);
    };

    this.markASample = (seconds: any) => {
      _ecgChart.markASample(seconds);
    };

    this.toggleBaseline = (reset: any) => {
      _ecgChart.toggleBaseline(reset);
    };

    this.updateSpeed = (speed: any) => {
      _ecgChart.updateSpeed(speed);
    };

    this.updateGain = (gain: any) => {
      _ecgChart.updateGain(gain);
    };

    this.updateHighLowPass = (isHighPass: any, freq: any) => {
      _ecgChart.updateHighLowPass(isHighPass, freq);
    };

    this.updatePrevChanIdx = (prevChanIdx: any) => {
      _ecgChart.updatePrevChanIdx(prevChanIdx);
    };

    this.getVisibleChannels = () => _ecgChart.getVisibleChannels();

    this.setVisibleChannels = (displayedChannelsArr: any) => {
      _ecgChart.setVisibleChannels(displayedChannelsArr);
    };

    this.toggleFineGrid = () => {
      _ecgChart.toggleFineGrid();
    };

    this.enterARBeatMode = () => {
      _ecgChart.enterARBeatMode();
    };

    this.exitARBeatMode = () => {
      _ecgChart.exitARBeatMode();
    };

    this.startZoom = (isZooming: any) => {
      _ecgChart.startZoom(isZooming);
    };

    this.exitZoom = () => {
      _ecgChart.exitZoom();
    };

    this.enterViewAllMode = () => {
      _ecgChart.enterViewAllMode();
    };

    this.exportAll = () => _ecgChart.exportAll();

    this.handleCapture = (captureDuration: any, highlightChannel: any) =>
      _ecgChart.handleCapture(captureDuration, highlightChannel);

    this.getRemainSeconds = () => _ecgChart.getRemainSeconds();

    this.cleanupData = () => {
      _ecgChart.cleanupData();
    };
  };
})();

export { ECGChart };
export default { ECGChart };
